import React from 'react';
import {NavLink as BaseNavLink} from 'react-router-dom';
import clsx from 'clsx';

const AppNavLink =
  ({ activeClassName, className, ref, ...validProps } : any) => (
    <BaseNavLink
      {...validProps}
      ref={ref}
      className={({ isActive }: any) => isActive ? clsx(activeClassName, className): className}
    />
  );

AppNavLink.displayName = 'AppNavLink';

export default AppNavLink;
